import { Component, OnInit } from '@angular/core';
import { injectViewContainerRef } from '@angular/core/src/render3/view_engine_compatibility';
import { ActivatedRoute } from '@angular/router';
import { DaoService } from 'src/app/servicos/dao.service';
import * as CanvasJS from '../../../assets/canvasjs.min';

@Component({
  selector: 'app-censo-digital',
  templateUrl: './censo-digital.component.html',
  styleUrls: ['./censo-digital.component.css']
})
export class CensoDigitalComponent implements OnInit {

  constructor(public dao:DaoService,private route: ActivatedRoute) { }
  versaoApp: string = '';
  censo: any;
  unidades: any;
  aguardando: any;
  concluidos:any;
  pendentes:any;
  inconsistentes:any;
  comprovantes:any;
  semed:any = [];
  semusa:any = [];
  outros:any = [];
  semedFeito: number = 0;
  semusaFeito: number = 0;
  outrosFeito: number = 0;
  prod: any = {};
  porDia:any = {};
  porSecretaria = {};
  secretarias = [];
  porVersao: any = {};
  titulo: string = '';

  avaliacoes:any;
  comentarios:any;

  dadosGrafico: any = [{
    type: "pie",
		showInLegend: true,
    dataPoints: [
      { y: 450, name: "Food" },
      { y: 120, name: "Insurance" },
      { y: 300, name: "Traveling" },
    ]
  }];

  ngOnInit() {
    this.censo = this.route.params.subscribe(params => {
      this.censo = params['censo']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
      // console.log(this.censo);
      this.titulo = this.censo;
      this.iniciar();
   });

   
  }

senhaD:any;
mostrarComentarios: boolean = false;
esenha(){
  if(this.senhaD=='diviprev**'){
    this.mostrarComentarios = true;
  }else{
    this.dao.toast('e','senha inválida');
  }
}

  quantidade(lista){
    return lista && lista.length ? lista.length : 0;
  }

  percentual(parte, total){
    if(!total){
      return '0.00%';
    }

    return ((parte / total) * 100).toFixed(2) + '%';
  }

  percentualValor(parte, total){
    if(!total){
      return 0;
    }

    let valor = (parte / total) * 100;
    if(valor < 0) return 0;
    if(valor > 100) return 100;
    return valor;
  }

  percentualConclusao(){
    return this.percentual(this.quantidade(this.concluidos), this.quantidade(this.unidades));
  }

  percentualInconsistentes(){
    return this.percentual(this.quantidade(this.inconsistentes), this.quantidade(this.unidades));
  }

  percentualNaoManifestantes(){
    let total = this.quantidade(this.unidades);
    if(!total){
      return '0.00%';
    }

    let concluidosPercentual = (this.quantidade(this.concluidos) / total) * 100;
    let inconsistentesPercentual = (this.quantidade(this.inconsistentes) / total) * 100;
    return (100 - (concluidosPercentual + inconsistentesPercentual)).toFixed(2) + '%';
  }

  percentualNaoManifestantesValor(){
    let total = this.quantidade(this.unidades);
    if(!total){
      return 0;
    }

    return this.percentualValor(total - (this.quantidade(this.concluidos) + this.quantidade(this.inconsistentes)), total);
  }

  async iniciar(){
    let d = this.censo;
    // console.log(d);
    this.unidades = await this.dao.submeterSite({censo:d+''},'getUnidadePorCenso2');
    // console.log("carregou unidades",this.censo);
    this.porVersao = await this.dao.submeterSite({censo:d+''},'quantidadePorVersao');
    this.comentarios = await this.dao.submeterSite({censo:d+''},'obterTodosComentarios');
    // console.log(this.porVersao);
    let temp = await this.dao.submeterSite({},'versao');

    this.avaliacoes = await this.dao.submeterSite({},'obterAvaliacoes');
    // console.log("app versao",temp);
    this.versaoApp = temp.texto;
    this.mastigar();
  }

  salvarTexto (filename,data){

        
    let blob = new Blob([data], {type: 'text/csv'});
    if(window.navigator['msSaveOrOpenBlob']) {
        window.navigator['msSaveBlob'](blob, filename);
    }
    else{
        let elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;        
        document.body.appendChild(elem);
        elem.click();        
        document.body.removeChild(elem);
    }

}

  mastigar(){
    this.aguardando = [];
    this.concluidos = [];
    this.pendentes = [];
    this.inconsistentes = [];
    this.comprovantes = [];
    this.semed = [];
    this.semedFeito = 0;
    this.semusa = [];
    this.semusaFeito = 0;
    this.outros = [];
    this.outrosFeito = 0;
    this.prod = {};
    this.porDia = {};
    this.porSecretaria = {};
    this.secretarias = [];
    // console.log(this.unidades);
    for(let un of this.unidades){

      if(this.porSecretaria[un.secretaria]){
        this.porSecretaria[un.secretaria].quantidade++;
        if(un.situacao=='concluido')this.porSecretaria[un.secretaria].prontos++;
        if(un.situacao=='inconsistente')this.porSecretaria[un.secretaria].inconsistentes++;
        if(un.situacao=='aguardando')this.porSecretaria[un.secretaria].aguard++;
        if(un.situacao=='pendente')this.porSecretaria[un.secretaria].naoFez.push(un);
      }else{
        this.porSecretaria[un.secretaria] = {quantidade:1,prontos:0,inconsistentes:0,aguard:0,naoFez:[]};
        if(un.situacao=='concluido')this.porSecretaria[un.secretaria].prontos++;
        if(un.situacao=='inconsistente')this.porSecretaria[un.secretaria].inconsistentes++;
        if(un.situacao=='aguardando')this.porSecretaria[un.secretaria].aguard++;
        if(un.situacao=='pendente')this.porSecretaria[un.secretaria].naoFez.push(un);
      }

      if(un.situacao=='aguardando')this.aguardando.push(un);
      if(un.situacao=='pendente')this.pendentes.push(un);
      if(un.situacao=='concluido'){
        this.concluidos.push(un);
        this.processarProdutividade(un);
      }
      
      if(un.situacao=='inconsistente')this.inconsistentes.push(un);

      if(un.comprovante)this.comprovantes.push(un);

      if(un.secretaria=='SEMED'){
        if(un.situacao=='concluido')this.semedFeito++;
        this.semed.push(un);
      }else if(un.secretaria=='SEMUSA'){
        if(un.situacao=='concluido')this.semusaFeito++;
        this.semusa.push(un);
      }else{
        if(un.situacao=='concluido')this.outrosFeito++;
        this.outros.push(un);
      }

      

    }

    // console.log("o mapa",this.porSecretaria);

    for(let key in this.porSecretaria){
      this.secretarias.push({nome:key,prontos:this.porSecretaria[key]['prontos'],quantidade:this.porSecretaria[key]['quantidade'],inconsistentes:this.porSecretaria[key]['inconsistentes'],aguardando:this.porSecretaria[key]['aguard'],naoFez:this.porSecretaria[key]['naoFez']})
    }

    // console.log("SECRETARIAS",this.secretarias);

    this.montarGrafico();
    this.montarProdutividade();
    this.montarVersao();
  }

  mascaraCPF(cpf){
    let res = ((cpf+'').slice(0, 3))+'.***.***-**';
    return res;
  }

  ordenar(lista,campo){ // ordena json pelo nome do campo
    let res = [];
    lista.sort((a,b)=>{
        return (a[campo]+'').trim().toLowerCase()>(b[campo]+'').trim().toLowerCase() ? 1: (a[campo]+'').trim().toLowerCase()<(b[campo]+'').trim().toLowerCase() ?-1:0;
    });
    res = lista;
    return res;
  }

  listarNaoFez(secr){
    // console.log(secr);

    let dados = "Nome;CPF;Secretaria \n";
    if(!secr['naoFez'] && !secr['naoFez'].length){
      this.dao.toast('e','Não há dados para exportar');
      return;
    }

    secr['naoFez']=this.ordenar(secr['naoFez'],'nome');

    for(let reg of secr['naoFez']){
      dados+=reg.nome+';'+this.mascaraCPF(reg.cpf)+';'+reg.secretaria+'\n';
    }

    this.salvarTexto('NaoFizeram.csv',dados);

  }

  processarProdutividade(it){
    if(!it.nome_usuario)return;

    this.processarDiario(it); // processa producao diaria
    if(this.prod[it.nome_usuario]){
      this.prod[it.nome_usuario]++;
      return;
    }

    this.prod[it.nome_usuario]=1;
    
  }

  processarDiario(it){
    let t = it.momento_conclusao.split(" ")[0];
    if(this.porDia[t]){
      this.porDia[t]++;
      return;
    }

    this.porDia[t]=1;
  }

  montarProducaoDiaria(){
    let dado = [{
      type: "column",
      // showInLegend: true,
      dataPoints: []
    }];

    // console.log(this.porDia);
    for(let key in this.porDia){
      dado[0].dataPoints.push({y:this.porDia[key],label:key});
    }

    let chart = new CanvasJS.Chart("porDia", {
      theme: "light2",
      
      animationEnabled: true,
      exportEnabled: true,
      title:{
        text: "Produção Por Dia"
      },
      data:dado
    });

    chart.render();
  }

  montarVersao(){
    let dado = [{
      type: "column",
      // showInLegend: true,
      dataPoints: []
    }];

    for(let key of this.porVersao){
      // console.log({y:key['quantidade'],label:key['versao']});
      dado[0].dataPoints.push({y:parseInt(key['quantidade']),label:key['versao']});
    }

    let chart = new CanvasJS.Chart("porVersao", {
      theme: "light2",
      
      animationEnabled: true,
      exportEnabled: true,
      title:{
        text: "Por versao do APP"
      },
      data:dado
    });

    chart.render();

    
  }

  montarProdutividade(){
    let dado = [{
      type: "column",
      // showInLegend: true,
      dataPoints: []
    }];

    for(let key in this.prod){
      dado[0].dataPoints.push({y:this.prod[key],label:key});
    }

    let chart = new CanvasJS.Chart("produtividade", {
      theme: "light2",
      
      animationEnabled: true,
      exportEnabled: true,
      title:{
        text: "Quantitativos"
      },
      data:dado
    });

    chart.render();

    this.montarProducaoDiaria();
  }

  montarGrafico(){
    
    this.dadosGrafico[0].dataPoints = [];
    this.dadosGrafico[0].dataPoints.push({y:this.aguardando.length,name:'Para Conferir'});
    this.dadosGrafico[0].dataPoints.push({y:this.concluidos.length,name:'Concluidos'});
    this.dadosGrafico[0].dataPoints.push({y:this.pendentes.length,name:'Pendentes'});
    this.dadosGrafico[0].dataPoints.push({y:this.inconsistentes.length,name:'Inconsistentes'});
    let chart = new CanvasJS.Chart("pizza", {
      theme: "light2",
      
      animationEnabled: true,
      exportEnabled: true,
      title:{
        text: "Quantitativos"
      },
      data:this.dadosGrafico
    });

    chart.render();
  }

}
